<mat-toolbar color="accent">
  <mat-toolbar-row class="pm-main-toolbar">
    <span><button mat-icon-button (click)="onMenuClicked()" id="proman-sidenav-button"><mat-icon>menu</mat-icon></button></span>
    <button class="only-large proman-logo" mat-button (click)="showAbout()">
      <mat-icon svgIcon="proman-logo" class="pm-logo"></mat-icon>
    </button>

    <span>@if (!(isLoading$ | async) && !(isTemplateTree$| async) && (isOnline$ | async)) {
      <button matTooltip="{{'menu.toolbar.refresh-page' | translate}}" (click)="onReloadClicked()"
              mat-icon-button><mat-icon>refresh</mat-icon></button>
    }</span>
    @if (isLoading$ | async) {
      <span class="progress-spinner-wrapper">
          <mat-progress-spinner mode="indeterminate"
                                [diameter]="24"
                                [strokeWidth]="3"
                                [@spinner]></mat-progress-spinner>
        </span>
    }
    @if (isOnline$ | async) {
      <span>
          @if (!(isTemplateTree$| async)) {
            <button matTooltip="{{'menu.toolbar.favorites' | translate}}" mat-icon-button
                    [matMenuTriggerFor]="favoriteMenu"><mat-icon>star</mat-icon></button>
          }
          </span>
    }
    <mat-menu #favoriteMenu="matMenu">
      @for (favorite of favorites$ | async; track favorite) {
        <button mat-menu-item (click)="onFavoriteClicked(favorite.id)">
          {{ favorite.label }}
        </button>
      }
    </mat-menu>
    @if (isOnline$ | async) {
      <span>
            @if (!(isTemplateTree$| async)) {
              <button matTooltip="{{'menu.toolbar.search' | translate}}" mat-icon-button (click)="showSearchPanel()"
              >
                <mat-icon>search</mat-icon>
              </button>
            }
          </span>
    }

    @if ((isAuthor$ | async) && !(isTemplateTree$| async)) {
      <span><button matTooltip="{{newProcessPageString | translate}}" mat-icon-button (click)="createClicked()">
            <mat-icon>note_add</mat-icon></button></span>
      <span><button matTooltip="{{'menu.toolbar.paint-format' | translate}}" mat-icon-button
                    [class.mat-elevation-z3]="formattingActive"
                    (click)="formatClicked()">
              <mat-icon>format_paint</mat-icon></button></span>
      <span><button id="pm-paste-button" matTooltip="{{'menu.toolbar.paste' | translate}}" mat-icon-button
                    (click)="onPasteClick()"><mat-icon>content_paste</mat-icon></button></span>
      <span><button matTooltip="{{'menu.toolbar.undo' | translate}}" mat-icon-button
                    [disabled]="!(hasUndo$ | async)" (click)="undo()"><mat-icon>undo</mat-icon></button></span>
      <span><button matTooltip="{{'menu.toolbar.redo' | translate}}" mat-icon-button
                    [disabled]="!(hasRedo$ | async)" (click)="redo()"><mat-icon>redo</mat-icon></button></span>
      <span>@if (!(isSaving$ | async)) {
        <button matTooltip="{{'menu.toolbar.save' | translate}}" mat-icon-button
                [disabled]="!(hasUndoNotTextEditing$ | async)" (click)="save()"><mat-icon>cloud_upload</mat-icon></button>
      }</span>
      @if (isSaving$ | async) {
        <span class="progress-spinner-wrapper">
                          <mat-progress-spinner mode="indeterminate" [diameter]="24" [strokeWidth]="3"
                                                [@spinner]></mat-progress-spinner>
                        </span>
      }
    }

    <span>@if ((isAuthor$ | async) && (templatesEnabled$ | async)) {
      <button
        matTooltip="{{'menu.toolbar.templates' | translate}}" mat-icon-button
        (click)="toggleTemplates()" [class.mat-elevation-z3]="templatesShowing$ | async"><mat-icon>inventory_2</mat-icon></button>
    }
                    </span>
    <span>@if ((isTemplateTree$ | async)) {
      <button
        matTooltip="{{'menu.toolbar.templates.return' | translate}}" mat-icon-button
        (click)="exitTemplate()"><mat-icon>close</mat-icon></button>
    }
                    </span>

    <span class="toolbar-push-right"></span>
    @if ((languages$ | async)?.length > 1 && (isOnline$ | async)) {
      <pm-language-selector class="only-medium-and-large" [languages]="languages$ | async"
                            [isTemplateTree]="isTemplateTree$ | async"
                            [currentLanguage]="currentLanguage | async" (languageChange)="selectLanguage($event)"
      ></pm-language-selector>
    }
    <pm-history-view></pm-history-view>
    <pm-view-options-menu [translationHighlight]="translationHighlight$ | async" [labelSettings]="labelsView$ | async"
                          (labelChange)="labelsViewChange($event)"
                          (highlightChange)="highlightChange($event)" [showHighlightButton]="!(isTemplateTree$| async)"
                          (showUnsearchableChange)="showUnsearchableChange($event)"
                          (showBackLinksChange)="showBackLinksChange($event)"
                          [showUnsearchable]="showUnsearchable$ | async"
                          [showBackLinks]="showBackLinks$ | async"></pm-view-options-menu>
    <span>@if (isOnline$ | async) {
      <button class="only-medium-and-large" matTooltip="{{'dialog.logbook.title' | translate}}"
              mat-icon-button (click)="onLogbookClick()"><mat-icon>notes</mat-icon></button>
    }</span>
    <span>@if (canFullscreen) {
      <button class="only-medium-and-large" matTooltip="{{'menu.toolbar.fullscreen' | translate}}"
              mat-icon-button
              (click)="onFullscreen()"><mat-icon>fullscreen</mat-icon></button>
    }</span>
    <span><button class="only-medium-and-large" matTooltip="{{'menu.toolbar.logoff' | translate}}" mat-icon-button
                  (click)="onLogout()"><mat-icon>exit_to_app</mat-icon></button></span>
    <span><button class="only-small" matTooltip="More..." mat-icon-button [matMenuTriggerFor]="smallDeviceMenu"><mat-icon>more_vert</mat-icon></button></span>
  </mat-toolbar-row>
  <mat-toolbar-row class="pm-bread-crumbs-toolbar">
    <pm-breadcrumbs></pm-breadcrumbs>
  </mat-toolbar-row>
</mat-toolbar>
<mat-menu #smallDeviceMenu="matMenu">
  @if ((languages$ | async)?.length > 1 && (isOnline$ | async)) {
    <pm-language-selector [languages]="languages$ | async" [currentLanguage]="(currentLanguage | async)"
                          [isTemplateTree]="isTemplateTree$ | async" (languageChange)="selectLanguage($event)"
                          (click)="$event.stopPropagation()">
    </pm-language-selector>
  }
  @if (isOnline$ | async) {
    <a mat-menu-item (click)="onLogbookClick()">{{ 'dialog.logbook.title' | translate }}</a>
  }
  @if (canFullscreen) {
    <button mat-menu-item
            (click)="onFullscreen()">{{ 'menu.toolbar.fullscreen' | translate }}
    </button>
  }
  <button mat-menu-item (click)="onLogout()">{{
      'menu.toolbar.logoff'
        | translate
    }}
  </button>
</mat-menu>
